import tw, { styled } from "twin.macro"

const SubHeader = styled.h3`
  ${tw`text-3xl text-center leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 my-6`}
`

export default SubHeader
